var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"breadcrumbs"},[_vm._l((_vm.breadcrumbs),function(ancestor){return [_c('span',{staticClass:"md-icon"},[_vm._v(_vm._s(ancestor.getIcon()))]),_c('span',{staticClass:"crumb",on:{"click":(e) => ancestor.open(e)}},[_vm._v(_vm._s(ancestor.getShortText()))]),_c('span',{staticClass:"slash"},[_vm._v("/")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }